// Premium (クラウド同期) のエンタイトルメント判定。mobile/src/lib/premium.ts の移植。
// 判定・カットオフを変えるときは mobile と必ず同時に変えること
// (__tests__/lib/premium.test.ts のパリティテストが一致を検査している)。
//
// 方針 (2026-09-21 決定):
// - 無料版はローカルオンリー (Web は当面、匿名ゲストモードが受け皿)
// - 有料化リリース (GRANDFATHER_CUTOFF) より前に作られたアカウントは同期無料のまま
// - 判定はサインイン後に一本化 (サインアップ画面を塞ぐ方式は Google/Apple
//   サインインで新規アカウントが素通りするため採らない)

// 有料化リリース日時 (UTC)。リリース確定時に実際の公開日へ更新すること (mobile と両方)
export const GRANDFATHER_CUTOFF_ISO = "2026-10-01T00:00:00Z";

export type PremiumReason =
  | "subscription" // subscriptions テーブル (Stripe 購入 / RevenueCat webhook / 手動付与)
  | "purchase" // RevenueCat のエンタイトルメント (Web では未使用。mobile とのパリティ用)
  | "grandfathered" // カットオフ以前のアカウント
  | "none";

export interface PremiumStatus {
  isPremium: boolean;
  reason: PremiumReason;
}

export interface PremiumInputs {
  userCreatedAt: string | null | undefined;
  subscription: { plan_type: string; status: string } | null;
  hasActiveEntitlement: boolean;
}

export function isActiveSubscription(
  subscription: { plan_type: string; status: string } | null,
): boolean {
  return subscription?.plan_type === "pro" && subscription?.status === "active";
}

export function isGrandfathered(
  userCreatedAt: string | null | undefined,
  cutoffIso: string = GRANDFATHER_CUTOFF_ISO,
): boolean {
  if (!userCreatedAt) return false;
  const created = Date.parse(userCreatedAt);
  if (Number.isNaN(created)) return false;
  return created < Date.parse(cutoffIso);
}

export function resolvePremiumStatus(inputs: PremiumInputs): PremiumStatus {
  if (isActiveSubscription(inputs.subscription)) {
    return { isPremium: true, reason: "subscription" };
  }
  if (inputs.hasActiveEntitlement) {
    return { isPremium: true, reason: "purchase" };
  }
  if (isGrandfathered(inputs.userCreatedAt)) {
    return { isPremium: true, reason: "grandfathered" };
  }
  return { isPremium: false, reason: "none" };
}
